<script>
    import { onMount } from "svelte"
    import { firebase, firestore } from "../../firebase/firebase.js";
    import BorderLoader from "../../components/BorderLoader.svelte"
    import EmptyText from "../../components/EmptyText.svelte"
    import { updateLanguagePanel } from '../../store/shared.js';
    export let currentRoute;
    export let params;

    var rLangLoader = false;
    var sLangLoader = false;
    var addLangLoader = false;
    var removeLangLoader = false;
    var removeLangLoader = false;
    var rawLanguages = [];
    var backUpRawLanguages = [];
    var selectedLanguages = [];

    var currentRawLang = '';
    var currentSelectedLang = '';

    var searchText = '';

    var isAddingNewLang = false;
    var newLangName = '';
    var newLangCode = ''
    var addNewLangError = ''
    var newLangLoader = false;

    $: {
        if (searchText) {
            filterLanguages()
        } else {
            rawLanguages = [...backUpRawLanguages]
            filterRawLanguages();
        }
    }

    function filterLanguages() {
        const rawFiltered = backUpRawLanguages.filter(lang => lang.data()['name'].toLowerCase().search(searchText.toLowerCase()) >= 0)
        rawLanguages = [...rawFiltered]
    }

    onMount(async () => {
        await init();
    })

    async function init() {
        await fetchRawLanguages();
        await fetchSelectedLanguage();
        filterRawLanguages();
    }

    async function initReverse() {
        await fetchSelectedLanguage();
        await fetchRawLanguages();
        filterRawLanguages();
    }

    async function fetchRawLanguages() {
        rLangLoader = true;
        try {
            var res = await firestore.collection('rawLanguages').get();

            if (res && res.docs && res.docs.length != 0) {
                rawLanguages = [...res.docs];
                backUpRawLanguages = [...res.docs]
            } else {
                rawLanguages = [];
                backUpRawLanguages = [];
            }
        } catch (error) {

        }
        rLangLoader = false;
    }

    async function fetchSelectedLanguage() {
        sLangLoader = true;
        try {
            var res = await firestore.collection('selectedLanguages').get();
            if (res && res.docs && res.docs.length != 0) {
                selectedLanguages = [...res.docs];
            } else {
                selectedLanguages = [];
            }
        } catch (error) {

        }
        sLangLoader = false;
    }

    function filterRawLanguages() {
        if (rawLanguages && rawLanguages.length != 0 && selectedLanguages && selectedLanguages.length != 0) {
            selectedLanguages.forEach(sLang => {
                var index = rawLanguages.map((rLang) => rLang.data()['code']).indexOf(sLang.data()['code']);
                if (index >= 0) {
                    rawLanguages.splice(index, 1);
                }
            })
            rawLanguages = [...rawLanguages]
            backUpRawLanguages = [...rawLanguages]
        }
    }

    function setCurrentRawLang(lang) {
        currentRawLang = lang

    }

    function setCurrenSelectedLang(lang) {
        currentSelectedLang = lang

    }

    async function removeLang() {
        if (currentSelectedLang && !removeLangLoader) {
            removeLangLoader = true;
            await firestore.collection('selectedLanguages').doc(currentSelectedLang.id).delete()
            await initReverse()
            removeLangLoader = false;
            updateLanguagePanel.update(old => !old);
        }
    }

    async function addLang() {
        if (currentRawLang && !addLangLoader) {
            addLangLoader = true;
            if (!rawLanguages.some(l1 => selectedLanguages.map(function (e) { return e.data()['code']; }).indexOf(l1.data()['code']) >= 0)) {
                await firestore.collection('selectedLanguages').doc(currentRawLang.id).set({
                    code: currentRawLang.id,
                    name: currentRawLang.data()['name'],
                })
                await init()
            }
            addLangLoader = false;
            updateLanguagePanel.update(old => !old);
        }
    }

    async function addNewLang() {
        if (!newLangLoader) {
            newLangLoader = true;
            try {
                if (newLangName && newLangCode) {
                    var result = await firestore.collection('rawLanguages').doc(newLangCode).get();
                    if (!result || !result.exists) {
                        await firestore.collection('rawLanguages').doc(newLangCode).set({
                            name: newLangName,
                            code: newLangCode,
                        })
                            .then(async result => {
                                isAddingNewLang = false;
                                searchText = '';
                                await init();
                            })
                            .catch(error => {
                                addNewLangError = error["message"];
                            })
                            .finally(() => {
                                newLangLoader = false;
                            })
                    } else {
                        addNewLangError = 'Code already taken';
                    }
                }
            } catch (error) {

            }
            newLangLoader = false;
        }
    }
</script>

<div class="wrapper">
    <div class="my_header">
        <div>
            Languages
        </div>
        <div class="d-flex">
            <button on:click="{() => {isAddingNewLang = true; newLangName = searchText}}" type="button"
                class="btn btn-outline-primary btn-sm mr-1">New</button>
        </div>
    </div>
    {#if !isAddingNewLang}
<div class="flex-column justify-content-center align-items-center mt-5 row no-gutters">
    <div class="d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column align-items-end">
            <small id="rawLanguagesHelpText" style="line-height: initial !important;" class="form-text text-muted">
                All languages
            </small>
            <ul class="list-group lang-list">
                {#if !rLangLoader}
                    {#if rawLanguages && rawLanguages.length != 0}
                        {#each rawLanguages as lang, i}
                            <button on:click="{setCurrentRawLang(lang)}" style="text-align: left !important; font-size: 13px; width: 100% !important;"
                                class:active="{currentRawLang && currentRawLang.id == lang.id}" class:list-group-item="{true}" class:list-group-item-action="{true}">{ lang.data()['name'] }</button>
                        {/each}
                    {:else}
                        <div class="h-100 w-100 align-items-center justify-content-center" style="display: flex; flex-direction: column;">
                            <div style="font-size: 13px; min-height: 20px;" class="text-secondary">No languages</div>
                            <div>
                                <button on:click="{() => {isAddingNewLang = true; newLangName = searchText}}" style="border-radius: 0 !important;" type="button" class="btn btn-sm btn-outline-primary">New</button>
                            </div>
                        </div>
                    {/if}
                {:else}
                    <BorderLoader />
                {/if}
            </ul>
            <button on:click="{addLang}" style="border-radius: 0 !important; font-size: 8px;" type="button" class="btn btn-sm btn-outline-primary"><span class="fa fa-plus"></span></button>
        </div>
        <div class="px-2">
           <span class="fa fa-exchange-alt" style="color: gray;"></span>
        </div>
        <div class="d-flex flex-column align-items-start">
            <small id="rawLanguagesHelpText" style="line-height: initial !important;" class="form-text text-muted">
                Live languages
            </small>
            <ul class="list-group lang-list">
                {#if !sLangLoader}
                    {#if selectedLanguages && selectedLanguages.length != 0}
                        {#each selectedLanguages as lang, i}
                            <button on:click="{setCurrenSelectedLang(lang)}" style="text-align: left !important; font-size: 13px; width: 100% !important;"
                                class:active="{currentSelectedLang && currentSelectedLang.id == lang.id}" class:list-group-item="{true}" class:list-group-item-action="{true}">{ lang.data()['name'] }</button>
                        {/each}
                    {:else}
                        <EmptyText msg="No languages"/>
                    {/if}
                {:else}
                    <BorderLoader />
                {/if}
            </ul>
            <button style="border-radius: 0 !important; font-size: 8px;" on:click="{removeLang}" type="button" class="btn btn-sm btn-outline-primary"><span class="fa fa-minus"></span></button>
        </div>
    </div>
    <div style="width: 530px;">
        <div class="input-group mt-3 mb-3">
            <input bind:value="{searchText}" placeholder="Search" type="text" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
          </div>
    </div>
</div>
{:else}
<div class="flex-column justify-content-center align-items-center mt-5 row no-gutters">
    <div class="d-flex" style="flex-direction: column;">
        <div style="font-size: 15px; min-height: 20px;" class="text-secondary">New Language</div>
        <input bind:value="{newLangName}" placeholder="Name" type="text" class="mb-3 form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
        <input bind:value="{newLangCode}" placeholder="Code" type="text" class="mb-3 form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">


        {#if newLangLoader}
            <button style="border-radius: 0 !important;"  class="mb-3 btn btn-sm btn-primary" type="button">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
            </button>
        {:else}
            <button on:click="{addNewLang}" style="border-radius: 0 !important;" type="button" class="mb-3 btn btn-sm btn-primary">Save</button>
        {/if}
        
        <button on:click="{() => isAddingNewLang = false}" style="border-radius: 0 !important;" type="button" class="btn btn-sm btn-outline-primary">Cancel</button>
        {#if addNewLangError}
            <div style="font-size: 15px; min-height: 20px;" class="mt-3 text-center text-danger">{ addNewLangError }</div>
        {/if}
    </div>
</div>
{/if}
</div>

<style>
    .wrapper{
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }
    .lang-list{
        width: 250px !important;
        min-width: 250px !important; 
        max-width: 250px !important; 
        height: 400px !important;
        overflow-y: auto !important;
        border: 1px solid darkgray !important;
    }

    .my_header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }
</style>